import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

const CustomDate = forwardRef((props, ref) => {
  const [portal, setPortal] = useState(false);
  const [day, setDay] = useState();
  const refInput = useRef(null);
  const dateRef = useRef(null);

  const onDateChanged = (selectedDates) => {
    setDay(selectedDates);
    dateRef.current = selectedDates;
    props.onDateChanged();
  };

  useEffect(() => {
    if (refInput.current) {
      setPortal(true);
    }
  }, []);

  useEffect(() => {
    if (portal) {
      var element = document.getElementById("custom-date");
      if (element) element.classList.add("ag-custom-component-popup");
    }
  }, [portal]);

  useImperativeHandle(ref, () => ({
    getDate() {
      return dateRef.current;
    },
    setDate(date) {
      dateRef.current = date;
      setDay(date);
    },
  }));

  return (
    <div className="ag-input-wrapper" role="presentation">
      <DatePicker
        ref={refInput}
        selected={day}
        onChange={onDateChanged}
        dateFormat="yyyy-MM-dd"
        portalId="custom-date"
      />
    </div>
  );
});

export default CustomDate;
